import React, { useEffect } from "react";
import AutoResizeTextarea from "./AutoResizeTextarea.jsx";
import ToimenpideEhdotukset from "./ToimenpideEhdotukset.jsx";

/**
 * SubsectionListBlock
 * Each subsection now includes two text fields:
 * 1. Kuvaus / Havainnot
 * 2. Johtopäätökset / Arviointi
 */
export default function SubsectionListBlock({
  data,
  onChange,
  availablePTSSections,
  sections,
  setSections,
  kiinteisto,
  activeSection,
}) {
  const subsections = Array.isArray(data?.subsections)
    ? data.subsections
    : [];

  // 🪄 Auto-load from DB if empty
  useEffect(() => {
    if ((!subsections || subsections.length === 0) && activeSection?.subsections?.length > 0) {
      const initializedSubs = activeSection.subsections.map((s) => ({
        id: s.id || null,
        name: s.name || "",
        description: s.kuvaus || s.text || "",
        conclusion: s.havainnot || "",
        actionItems: [],
      }));
      onChange({ ...data, subsections: initializedSubs });
    }
  }, [activeSection?.subsections]);

  const updateSubsection = (index, patch) => {
    const newSubs = subsections.map((s, i) =>
      i === index ? { ...s, ...patch } : s
    );
    onChange({ ...data, subsections: newSubs });
  };

  const addSubsection = () => {
    onChange({
      ...data,
      subsections: [
        ...subsections,
        { name: "Uusi aliosio", description: "", conclusion: "", actionItems: [] },
      ],
    });
  };

  const removeSubsection = (index) => {
    onChange({
      ...data,
      subsections: subsections.filter((_, i) => i !== index),
    });
  };

  return (
    <div className="border rounded p-3 bg-white mt-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <button
          type="button"
          className="btn btn-sm btn-outline-primary"
          onClick={addSubsection}
        >
          + Lisää aliosio
        </button>
      </div>

      {subsections.map((sub, subIndex) => (
        <div
          key={subIndex}
          className="border rounded p-3 mb-3 bg-light shadow-sm"
        >
          <div className="d-flex justify-content-between align-items-center mb-2">
            <input
              type="text"
              className="form-control form-control-sm fw-semibold"
              value={sub.name || ""}
              onChange={(e) =>
                updateSubsection(subIndex, { name: e.target.value })
              }
              placeholder="Aliosion nimi..."
            />
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              onClick={() => removeSubsection(subIndex)}
            >
              ✕
            </button>
          </div>

          {/* 📝 Kuvaus / Havainnot */}
         
          <AutoResizeTextarea
            className="form-control form-control-sm mb-2"
            rows={3}
            placeholder="Kirjoita kuvaus tai havainnot..."
            data={{ value: sub.description || "" }}
            onChange={(newData) => {
              const newValue = newData?.value || "";
              updateSubsection(subIndex, { description: newValue });
            }}
          />

          {/* 💬 Johtopäätökset / Arviointi */}
        
          <AutoResizeTextarea
            className="form-control form-control-sm mb-2"
            rows={3}
            placeholder="Kirjoita johtopäätökset tai arviointi..."
            data={{ value: sub.conclusion || "" }}
            onChange={(newData) => {
              const newValue = newData?.value || "";
              updateSubsection(subIndex, { conclusion: newValue });
            }}
          />

          {/* 🧱 Toimenpide-ehdotukset */}
          <ToimenpideEhdotukset
            data={{ items: sub.actionItems || [] }}
            onChange={(newData) =>
              updateSubsection(subIndex, { actionItems: newData.items })
            }
            availablePTSSections={availablePTSSections}
            sections={sections}
            setSections={setSections}
            kiinteistotunnus={kiinteisto?.kiinteistotunnus}
            parentSectionLabel={sub.name || ""}
            parentSectionKey={data?.name || activeSection?.name || ""}
            categoryLabel={data?.title || data?.name || ""}
          />
        </div>
      ))}
    </div>
  );
}